(() => {
let observer, timer, sequence = 0;
function connect() {
 const page = document.querySelector('.ks-cart-page');
 const content = page?.querySelector('.js-ajax-cart-content');
 const goal = page?.querySelector('[data-ks-goal]');
 if (!content || !goal) return;
 observer?.disconnect();
 async function refresh() {
  const current = ++sequence;
  try {
   const response = await fetch(goal.dataset.root + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
   if (!response.ok) throw new Error('cart');
   const cart = await response.json();
   if (current !== sequence || !goal.isConnected) return;
   if (cart.currency !== 'INR') return;
   const remaining = Math.max(0,54901-cart.items_subtotal_price);
   const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-IN',{style:'currency',currency:'INR'}).format(remaining/100);
   goal.querySelector('progress').value = Math.min(100,cart.items_subtotal_price/54901*100);
   goal.querySelector('[data-ks-goal-message]').textContent = remaining ? goal.dataset.remaining.replace('__AMOUNT__',amount) : goal.dataset.reached;
   document.querySelectorAll('[data-ks-cart-count]').forEach(el=>el.textContent=cart.item_count);
  } catch { const message=goal.querySelector('[data-ks-goal-message]'); if(message) message.textContent=goal.dataset.refreshError; }
 }
 observer = new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(refresh,150)});
 observer.observe(content,{childList:true,subtree:true,characterData:true});
}
connect();
document.addEventListener('shopify:section:load',connect);
})();
(() => {
 if (window.ksUpsellAddReady) return;
 window.ksUpsellAddReady = true;
 let busy = false;
 document.addEventListener('click', async event => {
  const button = event.target.closest('[data-ks-upsell-add]');
  if (!button) return;
  event.preventDefault(); event.stopImmediatePropagation();
  if (busy) return;
  busy = true;
  const original = button.textContent;
  const status = button.parentElement.querySelector('[role="status"]');
  button.disabled = true; button.textContent = button.dataset.adding;
  status.textContent = '';
  try {
   const response = await fetch(button.dataset.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:button.parentElement.querySelector('[data-ks-cart-variant]')?.value || button.dataset.ksUpsellAdd,quantity:1}]})});
   const result = await response.json();
   if (!response.ok) {status.textContent = typeof result.description === 'string' ? result.description : 'Unable to add this item. Please try again.';}
   else {location.reload(); return;}
  } catch {status.textContent = 'Could not confirm the update. Refresh your cart before trying again.';}
  button.disabled = false; button.textContent = original; busy = false;
 }, true);
})();
